module.exports = __webpack_public_path__ + "img/prize.1854aa7c.png";